var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-cost-type-expand"},[_c('Tableview',{attrs:{"fields":_vm.tableHeaders,"items":_vm.data.costs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }